import { FC, ReactChild } from 'react';

import { PessoaPossivelmenteSemNome } from 'view/component/AvatarPessoa/AvatarPessoa';
import { TempoAtras } from 'view/component/Tempo/TempoAtras';
import { Spacing } from 'styles/theme/Tema';
import { Negrito, LoadingTexto } from 'view/component/Tipografia/Texto';
import { SolicitacaoDetalhada } from 'model/solicitacao/SolicitacaoDetalhada';
import { RotulosPessoaSolicitacao } from './RotulosPessoaSolicitacao';

import styled from 'styled-components';
import { NomePessoa } from '../Pessoa/NomePessoa';
import { AvatarPessoaPesquisavel } from '../AvatarPessoa/AvatarPessoaPesquisavel';
import { Dayjs } from 'dayjs';


interface SolicitacaoAtividadeProps {
  id: number
  pessoa: PessoaPossivelmenteSemNome
  solicitacao: SolicitacaoDetalhada
  dataCadastro: Dayjs
  prefixoLink: string;
  rotulos?: ReactChild;
}

export const SolicitacaoAtividade: FC<SolicitacaoAtividadeProps> = ({id, pessoa, children, solicitacao, dataCadastro, prefixoLink, rotulos}) => {
  const avatarPessoa = pessoa ?? {idInstitucional: "", nome: "Sistema"}

  return (
    <SolicitacaoAtividadeEsqueleto ancora={`${prefixoLink}-${id}`} pessoa={avatarPessoa}>
      <header>
        <Nome><NomePessoa tipo='span' idInstitucional={pessoa.idInstitucional} /></Nome>

        <RotulosPessoaSolicitacao pessoa={pessoa} solicitacao={solicitacao} />
        {rotulos && rotulos}
        <HorarioLink href={`#${prefixoLink}-${id}`}>
          <TempoAtras data={dataCadastro} />
        </HorarioLink>
      </header>

      {children}
    </SolicitacaoAtividadeEsqueleto>
  )
}

export const SolicitacaoAtividadeCarregando: FC = () => {
  const pessoa = {idInstitucional: '', nome: undefined}
  return (
    <SolicitacaoAtividadeEsqueleto ancora="solicitacao-atividade-carregando" pessoa={pessoa}>
      <header>
        <Nome><LoadingTexto tipo='span' width={120} /></Nome> <span><LoadingTexto tipo='span' /></span>
      </header>

      <p>
        <LoadingTexto width={240} />
        <LoadingTexto width={200} />
      </p>
    </SolicitacaoAtividadeEsqueleto>
  )
}


interface SolicitacaoAtividadeEsqueletoProps {
  /**
   * Id único utilizado como âncora
   */
  ancora: string
  pessoa: PessoaPossivelmenteSemNome
}

export const SolicitacaoAtividadeEsqueleto: FC<SolicitacaoAtividadeEsqueletoProps> = ({pessoa, children, ancora}) => {
  return (
    <Container id={ancora} className="solicitacao-atividade">
      <ColunaFoto aria-hidden={true}>
        <AvatarPessoaPesquisavel idInstitucional={pessoa.idInstitucional} exibirNome={false} comLink={false} />
      </ColunaFoto>

      <ColunaConteudo className='solicitacao-atividade-conteudo'>
        {children}
      </ColunaConteudo>
    </Container>
  )
}


const Container = styled.article`
  display: flex;
  margin: ${Spacing.unit}px;

  &:target {
    animation: highlight 2s ease-in alternate;
    animation: highlight 1.5s cubic-bezier(.86,0,.07,1) alternate;
  }

  &:last-child .solicitacao-atividade-conteudo {
    border: none;
  }
`;

const ColunaFoto = styled.div`
  margin-right: ${Spacing.unit}px;
`;
const ColunaConteudo = styled.div`
  width: 100%;
  margin-top: ${Spacing.unit/2}px;
  padding-bottom: ${Spacing.unit}px;
  border-bottom: 1px solid ${p => p.theme.background.borda};
`;
const Nome = styled(Negrito)`
  margin-right: ${Spacing.unit/2}px;
`;
const HorarioLink = styled.a`
  margin-left: ${Spacing.unit/2}px;
`;